<template>
  <div>
    <el-select
      size="mini"
      placeholder="Tecnico Asignado"
      v-model="TechnicianId"
      filterable
      clearable
      :loading="techniciansLoading"
      :disabled="techniciansLoading"
      @change="handleTechnicianChange"
    >
      <el-option
        v-for="(item, index) in technicians"
        :key="index"
        :value="item.value"
        :label="item.label"
      >
        <span class="custom_option">
          <el-avatar size="small" :src="item.image"></el-avatar>
          {{ item.label }}
        </span>
      </el-option>
    </el-select>
  </div>
</template>

<script>
import { formatArrayToElSelect /*, formatDate, formatQty*/ } from "@/utils";

export default {
  name: "AsignedThecnicians",

  data() {
    return {
      TechnicianId: "",
      technicians: [],
      techniciansLoading: false
    };
  },

  async mounted() {
    await this.GetTechnicians();
  },
  methods: {
    formatArrayToElSelect,
    async GetTechnicians() {
      this.techniciansLoading = true;
      await this.$http
        .get("/api/users/technicians")
        .then((resp) => {
          console.log("Technicians response:", resp.data);
          this.technicians = this.formatArrayToElSelect(resp.data, {
            label: "FullName",
            value: "id"
          });
        })
        .catch((err) => {
          console.error(err);
        })
        .finally(() => {
          this.techniciansLoading = false;
        });
    },
    async handleTechnicianChange(technician) {
      // this.selectedTechnician = technician;
      // await this.onChangeCustomerService(this.requestType);
      this.$emit("ThecnicianChaged", technician);
    }
  }
};
</script>

<style scoped>
.custom_option {
  display: flex;
  align-items: center;
  gap: 8px;
}
</style>
